import { IBasicDataConfig } from "@interfaces/screens/basic-data-config.interface";
import { BasePresenter } from "@presenters/base/base.presenter";
import { useSelector } from "react-redux";
import { IProaService, ProaService} from "@services/proyecta/proa-form.service";
import { Utilities, Enums, queryString, Dictionary } from "@utils";
import { IDataConfig } from "@models/";

export class BasicDataPresenter extends BasePresenter<IBasicDataConfig> {
  private _service: IProaService;
  public currentLabels: Dictionary<string, string>;
  private _tableId: string = 'data-config-codes';
  public summaryConfig: any = [];
  public projectsGrouped: any[];
  public currentBudgetDetails: any;
  public subProjectsInfo: any;

  constructor(view: IBasicDataConfig) {
    super(view);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
    this.projectsGrouped = useSelector(this.context.proaStore.selectProjectsGrouped);
    this.subProjectsInfo = useSelector(this.context.proaStore.selectSubProjectsInfo);
    this.currentBudgetDetails = useSelector(this.context.proaStore.selectCurrentBudgetDetails);
    this._service = new ProaService();
  }

  private getBudgetId() {
    const query = queryString.parseUrl(window.location.href.replace("#", "")).query as any;
    return query.Id;
  }

  public consult() {
    this.dispatcher(this.context.proaStore.getSubProjectsInfo(this.getBudgetId()));
  }

  public getFormFeTabs() {
    let tabsArray: Array<any> = this.selectTabs(this.currentBudgetDetails);

    let tabsEmpty: any[] = [];
    let tabsShow: any[] = [];
    tabsArray = tabsArray.map((tab: any) => {
      let showTab = true;
      let Empty = true;
      let _tab: any = {
        title: tab.PPresCodSubvencion.Title,
        id: tab.PPresCodSubvencion.Id,
        grantCode: tab.PPresCodSubvencion.OCTAVIACodigoSubvencion,
      };
      this.subProjectsInfo.forEach((el: any) => { if(el?.find((step: any) => step.PPresCodSubvencionId === tab.PPresCodSubvencion.Id)) { Empty = false;} });
      this.projectsGrouped.forEach((pr: any) => { 
        if(pr?.SubProyectosAgrupadosId?.includes(tab.PPresCodSubvencion.Id)) {showTab = false;}
        if(pr.PPresCodSubvencionId === tab.PPresCodSubvencion.Id){ showTab = true; _tab.grouped = true;}
      })
      
      if(Empty) tabsEmpty.push(_tab.id)
      if(showTab) tabsShow.push(_tab)
      return _tab
    });

    return {tabsShow, tabsEmpty, tabsArray}
  }
  
  private selectTabs(data: any) {
    const tabsName: Array<string> = [];
    const result: Array<any> = [];

    data?.forEach((tab: any) => {
      const name = tab?.PPresCodSubvencion?.OCTAVIACodigoSubvencion;
      const indName = name?.substring(0, 1);
      if (!Utilities.isNullEmptyObject(indName)) {
        let addResult = false;
        switch (indName) {
          case Enums.Prefix.Contributions.toString():
            addResult = false;
            break;
          case Enums.Prefix.Donations.toString():
            addResult = tabsName.indexOf(name) === -1;
            break;
          default:
            addResult = Number.isInteger(Number.parseInt(indName)) && tabsName.indexOf(name) === -1;
            break;
        }
        if (addResult) {
          tabsName.push(name);
          result.push(tab);
        }
      }
    });
    return result;
  }

  public async initialize(feTabs: any, subProjectsGrouped: IDataConfig[]) {
    let items: any[] = [];
    let auxData: any[] = [];
    feTabs.forEach((tab: any) => { items.push({ id:tab.id, label:tab.title})});
    subProjectsGrouped.forEach((pr: any) => { auxData.push({ id:pr.PPresCodSubvencionId, subProject:pr.SubProyectosAgrupadosId, codePpal:[pr.PPresCodSubvencionId] })});
    this.view.state.setDataColumns(this.getReportColumns(items));
    this.view.state.setDataSource(auxData);
  }
  
  public onRowSelected(event: any, feTabs: any) {
    if(event.selectedRowsData.length) {
      let findTab = feTabs.find((fe: any) => event.selectedRowsData[0].codePpal[0] == fe.id);
      this.view.state.setRowSelected(event.selectedRowsData[0]);
      this.view.state.setCodesGrouped(event.selectedRowsData[0].subProject);
      this.view.state.setCodePpal([findTab.id]);
    }
  }

  public guardar(codesGrouped: any,codePpal: any, dataSource: any, rowSelected: any) {
    if(codesGrouped?.length && codePpal?.length){
      let newDataSource = dataSource?.length ? Utilities.copyObject(dataSource) as any : [];
      let findData = rowSelected ? newDataSource.find((ds: any) => ds.id == rowSelected?.id) : null;
      if(!findData){
        newDataSource.push({ id:codePpal[0], subProject:codesGrouped, codePpal: [codePpal[0]] });
      }else {
        findData.id = codePpal[0];
        findData.codePpal = [codePpal[0]];
        findData.subProject = codesGrouped;
      }
      this.view.state.setCodesGrouped(null);
      this.view.state.setCodePpal(null);
      this.view.state.setRowSelected(null);
      this.view.state.setDataSource(newDataSource);
    }
  }

  public limpiar() {
    this.view.state.setCodesGrouped(null);
    this.view.state.setCodePpal(null);
    this.view.state.setRowSelected(null);
  }

  public eliminar(dataSource: any, rowSelected: any) {
    let newDataSource = dataSource.filter((ds: any) => rowSelected?.id !== ds.id);
    this.view.state.setCodesGrouped(null);
    this.view.state.setCodePpal(null);
    this.view.state.setDataSource(newDataSource);
    this.view.state.setRowSelected(null);
  }

  public getItemsPpal(itemsGrouped: any, dataSource: any, feTabs: any, rowSelected: any) {
    let auxData: any[] = [];
    if(feTabs?.length){
        let subProjectsRow: any[] = [];
        dataSource?.map((data: any) => {
          data?.subProject?.forEach((codeId: any) => {subProjectsRow.push(codeId)});
        })
        feTabs.forEach((fe: any)=> {
          let item = {
            id: fe.id,
            label: fe.title
          }
          let codePpal = (rowSelected?.codePpal[0] == fe.id );
          let findDS = dataSource?.find((ds: any) => ds.codePpal[0] === fe.id);
          let validateDataSource = (!findDS  && !subProjectsRow.includes(fe.id) );
          let validateRow = ((itemsGrouped?.length && !itemsGrouped.includes(fe.id))  && !subProjectsRow.includes(fe.id) && !findDS) || (codePpal  && ((itemsGrouped?.length && !itemsGrouped.includes(fe.id)) || !itemsGrouped?.length ) );
          if( (validateDataSource && !itemsGrouped?.length) || (validateDataSource && itemsGrouped?.length && !itemsGrouped.includes(fe.id)) || (validateRow)) auxData.push(item);
        })
    }
    return auxData;
  }

  public getItemsGrouped(itemPpal: any, dataSource: any, feTabs: any, tabsEmpty: any, rowSelected: any): any[] {
    let auxData: any[] = [];
    let subProjectsRow: any[] = [];
    dataSource?.map((data: any) => {
      let auxItems = data?.subProject
      auxItems.forEach((codeId: any) => { subProjectsRow.push(codeId)});
    })
    feTabs.forEach((fe: any)=> {
      let item = {
        id: fe.id,
        label: fe.title
      }
      let codePpal = (rowSelected?.codePpal[0] == fe.id) ;
      let findDS = dataSource?.find((ds: any) => (ds.codePpal[0] === fe.id));
      let validateDataSource = (!findDS && !subProjectsRow.includes(fe.id) && tabsEmpty.includes(fe.id));
      let validateRow = (codePpal && (((itemPpal?.length && !itemPpal.includes(fe.id)) || !itemPpal?.length)) && !subProjectsRow.includes(fe.id) && tabsEmpty.includes(fe.id));
      if((validateDataSource && !itemPpal?.length) || (validateDataSource && (itemPpal?.length && !itemPpal.includes(fe.id))) || (validateRow)) auxData.push(item);
    })
    if(dataSource?.length && rowSelected){
      dataSource.forEach((data: any)=> {
        if(rowSelected?.codePpal[0] === data.id){
          let auxItems = data?.subProject
          auxItems.forEach((z: any)=> {
            let findTab = feTabs.find((a: any) => z == a.id);
            if(!!findTab){
              let item = {
                id: findTab.id,
                label: findTab.title
              }
              auxData.push(item);
            }
          })
        }
      })
    }
    return auxData;
  }

  public onValueChanged(event: any, feTabs: any, itemsGropued?: boolean) {
    if(itemsGropued){
      let auxItemsId: any[] = [];
      event.forEach((element: any) => {
        let findTab = feTabs.find((a: any) => element == a.id)
        auxItemsId.push(findTab.id)
      });
      this.view.state.setCodesGrouped(auxItemsId)
    }else this.view.state.setCodePpal(event || [])
  }

  public getGridProps() {
    let internalProps: any = {
      id: this._tableId,
      showRowLines: true,
      pager: null,
      columnChooser: null,
      filterRow: null,
      headerFilter: null,
      columnMinWidth: 200,
      editing: {
        mode: "cell",
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        useIcons: true,
      },
      export: { allowExportSelectedData: false },
      groupPanel: null,
      stateStoring: {
        enabled: true,
        type: "localStorage",
        storageKey: "storage_" + this._tableId
      },
      toolbar: {
        title: "Pruebas",
        addRow: { icon: "plus", text: "Pruebas" },
      },
      sorting: { mode:"none" },
      allowColumnResizing: true,
      columnResizingMode: "widget",
      wordWrapEnabled: true,
      selection:{ mode: 'single' }
    };

    return { ...internalProps };
  }

  private getReportColumns(feTabs: any) {
    return <any[]>[
      {
        title: this.currentLabels.get('CodigoPrincipal'),
        dataField: 'codePpal',
        id: 'codePpal',
        visible: true,
        dataType: 'string',
        alignment: 'center',
        items: feTabs,
        fieldType: Enums.FieldTypes.Select,
        width: '40%',
      },
      {
        title: this.currentLabels.get('SubProyectosAgrupados'),
        dataField: 'subProject',
        id: 'subProject',
        visible: true,
        dataType: 'string',
        alignment: 'center',
        fieldType: Enums.FieldTypes.Select,
        items: feTabs,
        multiple: true,
        width: '60%',
      }
    ];
  }

}